import React from "react";
import { useNavigate } from "react-router-dom";
import { Navbar, NavLogo } from "retro-react";

const DesktopHeader = () => {
    const navigate = useNavigate();

        return(
            <Navbar
                color="primary"
                pattern="noise" 
                style= {{
                    height: "50px",
                    position: "fixed"
                }}
            >
                <NavLogo>

                </NavLogo>
            </Navbar>
        );
}

export default DesktopHeader;